import type { ShipmentColumn } from '../../types/column-types'

export const clientNameColumn: ShipmentColumn = {
    key: 'clientName',
    dataIndex: ['client', 'name'],
    width: 100,
    title: 'Клиент',
}
